/* tslint:disable */
import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpRequest,
  HttpResponse,
  HttpHeaders,
} from "@angular/common/http";
import { BaseService as __BaseService } from "../base-service";
import { ApiConfiguration as __Configuration } from "../api-configuration";
import { StrictHttpResponse as __StrictHttpResponse } from "../strict-http-response";
import { Observable as __Observable } from "rxjs";
import { map as __map, filter as __filter } from "rxjs/operators";

import { RegisterLocal } from "../models/register-local";
import { LoginResponse } from "../models/login-response";
import { LoginLocal } from "../models/login-local";
import { Users } from "../models/users";
@Injectable({
  providedIn: "root",
})
class AccountService extends __BaseService {
  static readonly accountRegisterLocalPath = "/api/Account/RegisterLocal";
  static readonly accountLoginLocalPath = "/api/Account/LoginLocal";
  static readonly accountResendVerificationPath =
    "/api/Account/ResendVerification";
  static readonly accountValidateEmailPath = "/api/Account/ValidateEmail";
  static readonly accountGetUserByEmailPath = "/api/Account/GetUserByEmail";
  static readonly accountLogUserLogoutPath = "/api/Account/Log_UserLogout";

  constructor(config: __Configuration, http: HttpClient) {
    super(config, http);
  }

  /**
   * @param model undefined
   */
  accountRegisterLocalResponse(
    model: RegisterLocal
  ): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = model;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/Account/RegisterLocal`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      })
    );
  }
  /**
   * @param model undefined
   */
  accountRegisterLocal(model: RegisterLocal): __Observable<string> {
    return this.accountRegisterLocalResponse(model).pipe(
      __map((_r) => _r.body as string)
    );
  }

  /**
   * @param model undefined
   */
  accountLoginLocalResponse(
    model: LoginLocal
  ): __Observable<__StrictHttpResponse<LoginResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = model;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/Account/LoginLocal`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<LoginResponse>;
      })
    );
  }
  /**
   * @param model undefined
   */
  accountLoginLocal(model: LoginLocal): __Observable<LoginResponse> {
    return this.accountLoginLocalResponse(model).pipe(
      __map((_r) => _r.body as LoginResponse)
    );
  }

  /**
   * @param model undefined
   */
  accountResendVerificationResponse(
    model: LoginLocal
  ): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = model;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/Account/ResendVerification`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({
          body: (_r as HttpResponse<any>).body === "true",
        }) as __StrictHttpResponse<boolean>;
      })
    );
  }
  /**
   * @param model undefined
   */
  accountResendVerification(model: LoginLocal): __Observable<boolean> {
    return this.accountResendVerificationResponse(model).pipe(
      __map((_r) => _r.body as boolean)
    );
  }

  /**
   * @param params The `AccountService.AccountValidateEmailParams` containing the following parameters:
   *
   * - `validationGuid`:
   *
   * - `emailAddress`:
   */
  accountValidateEmailResponse(
    params: AccountService.AccountValidateEmailParams
  ): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.validationGuid != null)
      __params = __params.set(
        "validationGuid",
        params.validationGuid.toString()
      );
    if (params.emailAddress != null)
      __params = __params.set("emailAddress", params.emailAddress.toString());
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/Account/ValidateEmail`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({
          body: (_r as HttpResponse<any>).body === "true",
        }) as __StrictHttpResponse<boolean>;
      })
    );
  }
  /**
   * @param params The `AccountService.AccountValidateEmailParams` containing the following parameters:
   *
   * - `validationGuid`:
   *
   * - `emailAddress`:
   */
  accountValidateEmail(
    params: AccountService.AccountValidateEmailParams
  ): __Observable<boolean> {
    return this.accountValidateEmailResponse(params).pipe(
      __map((_r) => _r.body as boolean)
    );
  }

  /**
   * @param emailAddress undefined
   */
  accountGetUserByEmailResponse(
    emailAddress?: null | string
  ): __Observable<__StrictHttpResponse<Users>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (emailAddress != null)
      __params = __params.set("emailAddress", emailAddress.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/Account/GetUserByEmail`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Users>;
      })
    );
  }
  /**
   * @param emailAddress undefined
   */
  accountGetUserByEmail(emailAddress?: null | string): __Observable<Users> {
    return this.accountGetUserByEmailResponse(emailAddress).pipe(
      __map((_r) => _r.body as Users)
    );
  }
  accountLogUserLogoutResponse(): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/Account/Log_UserLogout`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  accountLogUserLogout(): __Observable<null> {
    return this.accountLogUserLogoutResponse().pipe(
      __map((_r) => _r.body as null)
    );
  }
}

module AccountService {
  /**
   * Parameters for AccountValidateEmail
   */
  export interface AccountValidateEmailParams {
    validationGuid?: null | string;
    emailAddress?: null | string;
  }
}

export { AccountService };
